import { render, staticRenderFns } from "./ProductMappingDialog.vue?vue&type=template&id=570ddddc"
import script from "./ProductMappingDialog.vue?vue&type=script&lang=js"
export * from "./ProductMappingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports